import type { VideoEvidence } from "../ChatEventTypes";
import type { MentionedVideoItem } from "../components/VideoMention";

/**
 * A clip as a mention, so the clipboard holds it in the same shape as a
 * citation. Evidence carries no `vm_` mention id of its own, so the video's
 * public id stands in, as it does for a source (see videoSourceMentions).
 *
 * `index` has no counterpart on evidence — it numbers a citation's marker in
 * the answer's text — so callers pass the clip's position in whatever list the
 * user is looking at. Nothing downstream of the clipboard identifies a clip by
 * it: `clipKey` uses the video id and the time range (see clipboardStore).
 */
export const videoMentionFromClip = (
	clip: VideoEvidence,
	index: number,
): MentionedVideoItem => ({
	id: clip.video_id,
	index,
	start_time_sec: clip.start_time,
	end_time_sec: clip.end_time,
	thumbnail_url: clip.thumbnail_url,
	aspect_ratio: clip.aspect_ratio,
	title: clip.title ?? null,
	video_id: clip.video_id,
	video_url: clip.video_url,
	video_duration: clip.video_duration,
	hls_ready: clip.hls_ready,
	influencer: clip.influencer,
	social_account: clip.social_account,
	view_count: clip.view_count,
	post_url: clip.post_url,
});
